// extracted by mini-css-extract-plugin
export var bodySections = "_66-8";
export var gray = "_66-7";
export var green = "_66-4";
export var iconContainer = "_66-9";
export var iconWidgetContainer = "_66-1";
export var phoneIcon = "_66-2";
export var red = "_66-5";
export var statusDot = "_66-3";
export var widgetContainer = "_66-0";
export var yellow = "_66-6";